import { render, staticRenderFns } from "./ResetPasswordDone.vue?vue&type=template&id=82a602b8&scoped=true"
import script from "./ResetPasswordDone.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDone.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordDone.vue?vue&type=style&index=0&id=82a602b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a602b8",
  null
  
)

export default component.exports